<template>
  <div class="order-details">
    <div class="container" v-if="data">
      <div>
        <h1 class="h3 container-title">{{ data.serial_no }} - 訂單詳細資料</h1>
        <div class="row justify-content-between">
          <nav aria-label="breadcrumb" class="col-auto">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">訂單管理</li>
              <li class="breadcrumb-item">
                <router-link class="text-light" :to="{ name: 'Order' }">
                  <span>訂單列表</span>
                </router-link>
              </li>
              <li class="breadcrumb-item">{{ data.serial_no }}</li>
            </ol>
          </nav>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <h5 class="card-title mb-3">訂購資料</h5>
          <div class="row">
            <div class="col-lg-6">
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">下單時間：</div>
                <div class="col-md-8 col-lg-9">
                  {{ new Date(data.created_at).format('yyyy-MM-dd hh:mm') }}
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">姓名：</div>
                <div class="col-md-8 col-lg-9">{{ data.orderer_name }}</div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">電話：</div>
                <div class="col-md-8 col-lg-9">{{ data.orderer_phone }}</div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">信箱：</div>
                <div class="col-md-8 col-lg-9">{{ data.orderer_email }}</div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">地址：</div>
                <div class="col-md-8 col-lg-9">{{ data.orderer_address }}</div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">付款方式：</div>
                <div class="col-md-8 col-lg-9">匯款</div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">取貨方式：</div>
                <div class="col-md-8 col-lg-9">宅配到府</div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">安裝時間：</div>
                <div class="col-md-8 col-lg-9">{{ data.installable_day }}</div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4 col-lg-3 text-gray">備註：</div>
                <div class="col-md-8 col-lg-9">{{ data.orderer_notice }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <h5 class="card-title mb-3">產品清單</h5>
          <div class="table-responsive">
            <table class="table align-middle mb-3 mb-md-5 text-nowrap">
              <thead>
                <tr>
                  <th scope="col">商品名稱</th>
                  <th scope="col">型號</th>
                  <th class="text-center" scope="col">價格</th>
                  <th class="text-center" scope="col">數量</th>
                  <th class="text-center" scope="col">小計</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in data.items" :key="item.id">
                  <td>{{ item.product ? item.product.name : '' }}</td>
                  <td>{{ item.specification || '' }}</td>
                  <td class="text-end">
                    <small>$ </small
                    >{{ internationalNumberFormat(item.unit_price || 0) }}
                  </td>
                  <td class="text-center">{{ item.quantity || 0 }}</td>
                  <td class="text-end fw-bold">
                    <small>$ </small
                    >{{
                      internationalNumberFormat(item.unit_price * item.quantity)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="d-flex justify-content-end mb-3 align-items-end">
            <small class="me-2 text-gray"
              >共 {{ data.items.length }} 件商品</small
            >
            <div>訂單總額 $ {{ internationalNumberFormat(data.price) }}</div>
          </div>
        </div>
      </div>
      <div class="float-end">
        <router-link class="btn btn-gradient" :to="{ name: 'Order' }">
          回訂單列表
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { order } from '@/http/api/order.js'
import { mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'OrderDetails',
  data () {
    return {
      data: null
    }
  },
  computed: {
    ...mapState(['token']),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.getData()
      }
    }
  },
  methods: {
    ...mapMutations([
      'AlertsInfo',
      'Alerted',
      'Loading',
      'Loaded',
      'SetErrMsg'
    ]),
    getData () {
      const vm = this
      vm.Loading()
      order
        .get(vm.$route.params.id, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.data = data.data
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    internationalNumberFormat (number) {
      return new Intl.NumberFormat('en-IN').format(number)
    }
  },
  created () {},
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
    }
  }
}
</script>
